
<button *ngIf="mapService.scene" class=" m-2 float-right" mat-mini-fab [color]="!checkAllOpts['sensors']?null:'primary'">
  <fa-icon style="margin-left: -5px;" [icon]="['far','wifi']" (click)="checkAll('sensors')"></fa-icon>
</button>
<h5 class="primary pt-2 pb-3">Sensors</h5>

<ul class="fdm-sidebar-scene-layers" *ngIf="!loading">

  <li *ngFor="let cur of sensors"  class="p-2" [ngClass]="{'primary-bg-light':cur == mapComp?.inspectorComp?.selected}">
    <a [routerLink]="[cur.annotationMode == 'PIN'?'poi':cur.annotationMode || 'poi',cur.id]" 
      (dblclick)="mapService.helper.sendCameraTo(cur)">
 
      <fa-icon color="primary" [icon]="cur['icon']" [fixedWidth]="true"></fa-icon> {{ cur.name }}  </a>
      <div class="float-right">
        <input type="checkbox" class="ml-1 fdm-checkbox" (change)="agroToggle(cur)" [(ngModel)]="plots[cur.id]"/>
      </div>
  
  </li>
</ul>
<hr class="mt-2 mb-2"/>

<button *ngIf="mapService.scene" class=" m-2 float-right" mat-mini-fab  [color]="!checkAllOpts['weatherStations']?null:'primary'">
    <fa-icon style="margin-left: -5px;" [icon]="['far','clouds-sun']"  (click)="checkAll('weatherStations')"></fa-icon>
  </button>
  <h5 class="primary pt-2 pb-3">Weather Stations</h5>
    

<ul class="fdm-sidebar-scene-layers"  *ngIf="!loading">
   
    <li *ngFor="let cur of stations"  class="p-2"   [ngClass]="{'primary-bg-light':cur == mapComp?.inspectorComp?.selected}">
      <a [routerLink]="[cur.annotationMode == 'PIN'?'poi':cur.annotationMode || 'poi',cur.id]" 
        (dblclick)="mapService.helper.sendCameraTo(cur)">
        <fa-icon color="primary" [icon]="cur['icon']" [fixedWidth]="true"></fa-icon> {{ cur.name }}
      </a>
      <div class="float-right">
          <input type="checkbox" class="mr-1" (change)="agroToggle(cur)" [(ngModel)]="plots[cur.id]"/>
      </div>
    </li>
  </ul>